//塞尔维亚
export default {
  line: "Линија",
  language: "Језик",
  common: [
    "Онлајн услуге",
  "Откажи суспензију",
  "Да ли да потрошим 10.000 RSD да бих извршио куповину!"
  ],
  upload: [
   "Отпремање...",
  "Погрешан формат",
  "Отпремљено успешно",
  "Отпремање није успело"
  ],
  vanPull: [
    "Нема више података",
    "Нема података"
  ],
  login: {
    title:'Пријавите се са корисничким именом и лозинком',
    title_txt:'Пријавите се користећи регистровани број мобилног телефона',
    text: [
      "Запамти корисничко име/лозинку",
      "Пријављивање...",
      "Пријави се сада"
    ],
    placeholder: [
      "Молимо унесите број телефона",
      "Молимо вас да унесете лозинку за пријаву"
    ],
    i18n: [
      "Немате {title} налог? {a} {line}",
      "Региструј се"
    ]
  },
  register: {
    text: [
      "Добродошли на регистрацију",
      "Слање СМС кода...",
      "Преузмите СМС код",
      "Регистрација...",
      "Региструјте се сада",
      "Направите налог, преузмите сада",
      "Регистрација броја мобилног телефона",
      "Регистрација имејлом",
      "Назад на пријаву",
      "Молимо вас да користите нерегистровани број телефона и имејл адресу"
    ],
    placeholder: [
      "Молимо вас да унесете свој број телефона",
      "Молимо вас да унесете СМС верификациони код",
      "Молимо вас да унесете лозинку за пријаву",
      "Молимо вас да потврдите лозинку",
      "Молимо вас да унесете позивни код",
      "Две лозинке су различите",
      "Молимо вас да унесете верификациони код",
      "Молимо вас да унесете број е-поште",
      "Не може почети са 0"
    ],
    i18n: [
      "Имате налог? {a} {line}",
      "Пријава"
    ]
  },
  home: {
    lucky: "Догађај још није отворен",
    map: "Локација",
    qywh: "Корпоративна култура",
    broadcast: "емитовање: „Честитамо нашем партнеру: {member} је препоручио/ла {vipname} да се придружи и добио/ла је промотивни бонус од {grade} {currency}!“,",
    menu: [
     "VIP зона",
      "Видео туторијал",
      "Награде за промоцију"
    ],
    taskHall: {
      title: [
        "Сала задатака",
          "Пословна сала",
          "Завршите задатке да бисте остварили профит"
      ]
    },
    memberList: {
      title: "Списак чланова",
      data: [
        "{member}, заврши данашње {num} задатке поруџбине!"
      ]
    },
    businessList: {
      title: "Листа трговаца",
      data: [
        "{member}",
        "Објави {num} појединачни задатак данас"
      ]
    },
    noticeTitle: ["Обавештење","Претходно","Следеће"],
    tabBar: ["Дом","Тим","T", "Мапа", "Мој"],
    msg: "Задатак није отворен",
    video: "Нема видео туторијала",
      message: "Имате нове вести",
      bonus:[
        '<p>Унесите лозинку да бисте добили новчану награду у црвеној коверти.</p><p>1. Лозинка се добија кроз активности компаније!</p><p>2. Радна група повремено издаје лозинке! Можете свакодневно пратити информације радне групе!</p><p>За детаље, обратите се „Менаџеру за регрутацију“</p>',
        'Лозинка се добија кроз активности компаније!',
        'Унесите код са црвене коверте',
        'Примите црвену коверту',
        'Честитамо на добијању бонуса у црвеној коверти {amount}'
    ]
  },
  vip: {
    title:[
      "ВИП ниво",
      "Придружите се чланству сада да бисте преузели задатке"
    ],
    user: {
      title: [
        "Ваш идентитет",
        "Посетиоци"
      ],
      label: "Дневни задаци",
      value: [
        "Датум ступања на снагу", "Једна година", "Молимо вас да се прво пријавите", "Период важења праксе", "Одбројавање за повраћај депозита", "Одбројавање за важење нивоа ЛП"
      ],
    },
    list: {
      label: "Дневни задаци:{number}",
      button: "Придружи се сада",
      text: [
        "Дневни профит", "Месечни приход", "Награда за регрутовање: Сви", "Бесплатно", "По поруџбини", "Приход од оцене", "Ефективни повраћај", "Датум истека", "Година", "Дан", "Период важења"
      ],
    },
    dialog: [
      "Да ли сте сигурни да желите да потрошите {currency} {amount} да бисте постали {name}?",
      "Тренутно сте {currname} и не можете бити {name}",
      "Да ли сте сигурни да желите да потрошите {currency} {amount} да бисте обновили {name}?",
    ],
    index: ["Откажи", "Потврди"],
    desc: [
      '{level} Погодности',
      'Основни приход',
      'Време',
      'Број задатака',
      'Приход',
      'Дневно',
      'Месечно',
      'Годишње',
      'Приход од запошљавања',//8
      'Ниво подређеног',
      'Коефицијент провизије за запошљавање',
      'Бонус за запошљавање',
      'Подрођени нивоа 1',
      'Подрођени нивоа 2',
      'Подрођени нивоа 3',
      'Попуст за једнодневни задатак',
      'Ниво подређеног',
      'Коефицијент попуста за задатак подређеног',//17
      'Износ попуста за задатак',
      'Подрођени нивоа 1',
      'Подрођени нивоа 2',
      'Подрођени нивоа 3',
      '3 дана',
      'Јединична цена задатка',
      'Детаљи пробног периода',//24
      'Пракса: Није потребна куповина, постоје 1 задатак дневно, провизија за сваки задатак је 3RSD, 3RSD дневно. Период праксе за приправнике је само 2 дана',
      'Пример провизије за задатак:',
      '<p>Ако подређени нивоа 1 заврше укупно 10.000 левских левских налога дневно, можете добити провизију за задатак од 300 левских левских левских</p><p>Ако подређени нивоа 2 заврше укупно 10.000 левских левских налога дневно, можете добити провизију за задатак од 200 левских левских</p><p>Ако подређени нивоа 3 заврше укупно 10.000 левских левских налога дневно, можете добити провизију за задатак од 100 левских левских</p>',
      'Опис бонуса за препоруку:',
      '<p>(Подређени нивоа 1) Директно позивате А да се придружи, А је ваш подређени нивоа 1.</p><p>(Подређени нивоа 2) А позива Б да се придружи, Б је ваш подређени нивоа 2.</p><p>(Подређени нивоа 3) Б позива Ц да се придружи, Ц је ваш ниво 3 подређена.</p><p>Напомена: Бонус за препоруку може се захтевати само за највиши бонус тренутног нивоа појединца.</p>',
    ]
  },
  lucky: {
      default:[
          "Срећно извлачење",
          "Преостали број извлачења:",
          "Запис о лутрији",
          "Правила лутрије",
          "<p>Учествујте у активностима компаније и искористите прилике за срећно извлачење!</p>",
          "Запис о добитном кориснику",
          ['Честитамо:{member}','Освојите награде {profit}'],
          "Честитамо,Освојите награде ",
          "затвори",
          "Време за извлачење је искоришћено",
          "Важи до"
      ],
    scattered:[
      'Број извлачења',
      'ПОЧЕТАК',
      '<p>1. Број извлачења се добија кроз активности компаније!</p><p>2. Свако извлачење троши 1 извлачење!</p><p>3. Након што освојите физичку награду, контактирајте менаџера за регрутацију да бисте регистровали своје податке и добили је!</p>',
      'Подсетник',
    ],
  },
  userLc:{
      default:[
      "Повећање богатства", "Записи", "Износ", "Период складиштења", "Износ депозита", "Унесите износ депозита", "Приход", "Пошаљи",//7
"Прво изаберите производ", "Молимо изаберите информације", "Профит", "Дан", "нема података", "Време куповине", "држава", "Време завршетка", "Стање", "Данашња зарада", "Куповина једним кликом"//18
      ],
    tabs: [
      "Листа производа",
      "Инвестирана листа"
     ],
    tips:'<p>VOISP „Wealth Enhance“ је начин компаније да свим запосленима на М нивоу пружи више начина за повећање прихода. Инвестициони пројекти су финансијски инвестициони пројекти које заједнички покрећу PAGE, банке, компаније за управљање имовином итд.!</p><p>Краткорочна инвестиција: стабилан приход, флексибилан избор циклуса! Краткорочна неактивна средства могу донети додатни приход кроз инвестиције!Дугорочна инвестиција: Већи приноси, неговање добре редовне инвестиционе штедње, већи приноси и остваривање својих снова кроз акумулацију!</p>'
  },
  newlist: {
    text: [
    "Нема евиденције", "Очекивани приход", "резултати", "купи време", "статус", "Крај времена"
    ],
    placeholder: [
     "нема више података",
      "нема података"
    ],
    i18n: [
     "Историја куповине",
    ]
  },
  product: {
    default: [
      "Стање на промотивном рачуну",
      "Износ почетне инвестиције",
      "Максимални износ инвестиције",
      "Циклус",
      "Дневна каматна стопа",
      "максимална",
      "Правила пројекта",
      "Износ пројекта",
      "Начин плаћања",
      "Износ почетне инвестиције",
      "Дневна добит",
      "Циклус објављивања",
      "Процењени приход"
    ],
    placeholder: [
     "Вратите главницу и приход по доспећу (нормално за празнике)",
      ", аутоматско поравнање у року од 24 сата",
      "{str} = укупан приход {income} {currency} + главница {money} {currency} = укупна главница и камата {total} {currency}",
      "Безбедносна лозинка"
    ]
  },
  user: {
    vipl:"Ниво партнера",
    hello:"Добродошао назад",
    default: [
      "Мој надређени", "Налог", "Код позивнице", "Излаз из пријаве", "Стање", "Злато", "Мој новчаник", "Печат", "Ограничење", "Добро", "Одлично", "Активирај 'Асистента за читање'", "Контактирај менаџера за запошљавање"
    ],
    myEarnings: {
            grid: ["Баланс","Јучерашња зарада","Данашња зарада","Зарада ове недеље","Зарада овог месеца","Зарада прошлог месеца","Укупан приход","Завршите задатак данас (PCE)","Преостали задаци за данас (PCE)","Данашња комисија","Попуст за задатак","Попуст за препоруку"]
        },
    grid: [
      "Стање", "Јучерашња зарада", "Данашња зарада", "Зарада ове недеље", "Зарада овог месеца", "Зарада прошлог месеца", "Укупан приход", "Завршите задатак данас (PCE)", "Преостали задаци данас (PCE)", "Данашња провизија", "Данашњи попуст"
    ],
    menu: [
      "Записи задатака",
      "Ревизорски задатак",
      "Управљање објављивањем",
      "Лични подаци",//3
      "Повезивање налога",
      "Дневни извод",
      "Рачуноводствени записи",//6
      "Позови пријатеље",
      "Извештаји тима",//8
      "Приручник за помоћ",//9
      "Кредитни резултат",//10
      "Преузми апликацију",//11
      "Извлачење",//12
      "Инвестициона зона",
      "Асистент за читање",
      "Профил компаније",
      "Видео туторијал",
      "Одличан тим",
      "Инвестициона зона",
      "Пратите SGM",
      "Награде за раст",
      "Црвена коверта",
      "Добротворност"
    ],
    positions:[
      "Моја позиција",
      "Тренутна позиција",
      "Следећа позиција",
      "Директно повезани члан М нивоа",
      "Члан тима М нивоа 3",
      "Тим нивоа 3 (број {пост})",
      "Испуните све услове да бисте контактирали менаџера за запошљавање ради унапређења ваше позиције!",
      "Опис позиције",
      "Пријавите се за позицију",
      "Информације о позицији"
    ],
    office:[
        "Информације о мојој позицији",
          "Детаљи о унапређењу на послу",
          "Опис посла у SGM",
          "Позиције у компанији",
          "Унапређење на послу",
          "Пошаљите своју пријаву",
          "Напредак унапређења",
          "Најмање ",
          "Услови нису испуњени",//8
          "чланови у тиму са три нивоа (1/2/3) морају постати ({name}).",
          "Тим мора имати више од ",
          " чланова"
    ],
    current:[
        "Тренутне позиције",
        "Укупан број чланова ЛП"
    ],
    subordinate:[
       "А-ниво", "Б-ниво", "Ц-ниво", "листа чланова", "укупан број људи", "Укупан приход", "Износ повлачења", "Приход тима", "Листа чланова", "корисник", "ниво", "Време придруживања", "Пробни период"
    ],
    follow:[
        "Званични канал SGM",
        "Пратите канал да бисте сазнали више о најновијим информацијама са SGM!"
    ]
  },
  userInfo: {
    default: [
      "Лични подаци", "Портрет главе", "Број мобилног телефона", "Додај банковни рачун", "Alipay", "Право име", "Лозинка за пријаву", "Лозинка за фонд", "Кликни на Подешавања", "Промени портрет главе", "Промени лозинку за пријаву", "Промени лозинку за фонд", "Пошаљи", "Испразни кеш меморију", "Одјави се"
    ],
    label: [
      "Оригинална лозинка за пријаву",
      "Нова лозинка за пријаву",
      "Потврђивање лозинки",
      "Оригинални код за новац",
      "Нови код за новац",
      "Потврдите лозинку"
    ],
    placeholder: [
      "Молимо вас да унесете оригиналну лозинку за пријаву",
      "Молимо вас да унесете нову лозинку за пријаву",
      "Молимо вас да потврдите лозинку за пријаву",
      "Молимо вас да унесете оригиналну лозинку за фонд",
      "Молимо вас да унесете нову лозинку за фонд",
      "Молимо вас да потврдите лозинку за фонд"
    ]
  },
  userSet: {
    default: [
      "Сертификација правог имена",
      "Детаљне информације",
      "Вежи Alipay",
      "Пошаљи"
    ],
    label: [
      "Право име", "QQ", "Alipay налог", "Alipay име"
    ],
    placeholder: [
      "Молимо вас да унесете право име (Моје име се користи за подизање готовине)",
      "Enter QQ number",
      "Please enter Alipay account",
      "Please enter Alipay name"
    ],
    tips: "Подсетник: Повезана банковна картица се не може модификовати, она се користи за ваше повлачење новца"
  },
  bindAccount: {
    default: [
      "Повежи налог",
      "Погледај туторијал",
      "Пошаљи"
    ],
    tabs: [
      "Налог",
      "Налог",
      "Налог"
    ],
    label: [
      "Упутства",
      "Додај снимак екрана",
      "Налог"
    ],
    placeholder: "Молимо вас да унесете свој {account} налог"
  },
  bankCard: {
    default: [
      "Повежи банковну картицу",
      "Аутентификуј сада",
      "Слање ...",
      "Додај сада",
      "Додај банковну картицу"
    ],
    tips: [
      "Молимо вас да завршите аутентификацију правим именом пре него што додате банковну картицу",
      "Име на вашем рачуну на банковној картици мора бити иста као и право име које сте аутентификовали, у супротном нећете моћи успешно да подигнете готовину."
    ],
    label: [
      "Име", "Назив банке", "Број банковног рачуна", "Шифра филијале"
    ],
    placeholder: [
      "Молимо вас да изаберете назив банке",
      "Молимо вас да унесете број банковног рачуна",
      "Молимо вас да унесете код филијале",
      "Потврди",
      "Откажи"
    ]
  },
  wallet: {
    default: [
      "Мој новчаник", "Допуна", "Повлачење", "Евиденција допуна", "Евиденција повлачења", "R", "W", "Допуна RSD"
    ],
    label: [
      "Начин повлачења", "Износ повлачења", "Лозинка фонда", "Пошаљи", "Број телефона", "Е-пошта", "IFSC", "Начин плаћања", "Опорезивање", "Стварно примљени износ"
    ],
    placeholder: [
      "Изаберите начин исплате",
      "Молимо вас да унесете износ исплате",
      "Молимо вас да унесете лозинку за фонд",
      "Молимо вас да изаберете начин исплате",
      "Молимо вас да унесете број мобилног телефона примаоца",
      "Молимо вас да унесете адресу е-поште примаоца",
      "Молимо вас да унесете IFSC примаоца",
      "Молимо вас да изаберете начин плаћања"
    ],
    msg: [
      "Још нисте поставили лозинку за фонд, молимо вас да је прво подесите.",
      "Још нисте повезали своју банковну картицу, прво је повежите",
      "<p>Време повлачења:</p><p>Понедељак: M9</p><p>Уторак: M8</p><p>Среда: M6/M7</p><p>Четвртак: M3/M4/M5</p><p>Петак: M1/M2</p><p>(Приправници од понедељка до недеље)</p><p>од 9 до 18 часова</p>"
    ]
  },
  recharge: {
    default: [
      "Допуна",
      "Детаљи допуне",
      "Запис о допуни",
      "Расположиво стање {money}, изаберите начин допуне",
      "Минимални износ је {currency} {min}, максимални {currency} {max}, накнада за обраду {fee}%",
      "Слање...",
      "Допуна сада",
      "Враћање",
      "Учитавање...",
      "Минимални износ је ${min}, максимални ${max}, накнада за обраду {fee}%"
    ],
    label: [
      "Износ допуне", "Канал допуне", "Назив трансфера", "Име платиоца", "Мобилни телефон платиоца", "УПИ рачун платиоца", "Е-пошта платиоца", "Налог за трансакцију"
    ],
    placeholder: [
      "Молимо вас да унесете износ допуне",
      "Молимо вас да изаберете канал допуне",
      "Молимо вас да унесете назив трансфера",
      "Појединачни минимални износ је {currency} {min}",
      "Појединачни максимални износ је {currency} {max}",
      "Молимо вас да унесете име платиоца",
      "Молимо вас да унесете број мобилног телефона платиоца",
      "Молимо вас да унесете UPI налог платиоца",
      "Молимо вас да унесете имејл адресу платиоца",
      "Молимо вас да отпремите снимак екрана трансфера",
      "Молимо вас да унесете број налога за трансакцију"
    ],
    info: [
      "Износ допуне", "Број поруџбине", "Банка", "Број рачуна", "Име", "Копија", "{type} Трансфер", "Снимак екрана трансфера", "Пошаљи", "IFSC код", "Тип рачуна", "Упутства за обраду"
    ],
    tips: [
      "Молимо вас да изаберете следећи метод за пренос одговарајућег износа како бисте избегли кашњење у финансијској провери.<br>Након трансфера, отпремите снимак екрана трансфера као потврду о верификацији",
      "Нема потребе да додајете пријатеље, скенирајте QR код да бисте ми пребацили новац",
      "Молимо вас да извршите трансфер у складу са информацијама у наставку",
      "Савет: Након успешне уплате, контактирајте онлајн службу како бисте навели број вашег чланског рачуна, износ допуне, број поруџбине, број рачуна депонента и време допуне, како би финансијско одељење могло благовремено да вам допуни средства.",
      "Напомена: молимо вас да пошаљете једну уплату за сваки трансфер",
      "Након трансфера, отпремите снимак екрана трансфера као сертификат о верификацији",
      "Савет: Након што је плаћање успешно, отпремите слику успешне трансакције",
      "<p>Подсетник за допуну:</p><p>Након што пошаљете налог за допуну, ако нисте у могућности да директно пређете на програм Ccash/Maya, можете користити снимак екрана да бисте сачували QR код у албум и користили QR код да бисте завршили плаћање!</p><p>(QR код важи за једно плаћање и забрањено је чување QR кода за друго плаћање)</p>"
    ]
  },
  task: {
    default: [
      "Листа задатака", "Захтеви за задатак", "Креирај", "Ревизија", "Отвори линк", "Копирај линк", "Јединична цена", "Пошаљи", "Одустајање", "Почни са приказивањем", "У току", "ПОЧНИ ЗАДАТАК",
    ],
    tabs: [
      "У току", "Ревизија", "Завршено", "Неуспешно", "Злонамерно", "Напуштено"
    ],
    msg: "Данашња мисија је завршена",
    msgSc: "Успешно примљено",
    msgTime: "Након завршетка одбројавања, задатак ће бити аутоматски завршен и његово прерано затварање неће бити важеће!",
    info: [
      "Детаљи задатка",
      "Наслов задатка",
      "Предности задатка",
      "Опис задатка",
      "Захтеви за отпремање",
      "Пошаљи узорак",
      "Корисник није послао узорак",
      "Белешке о ревизији",
      "Датум ревизије",
      "Страна потражње",
      "Објави",
      "Копирај",
      "Скочи",
      "Кораци задатка",
      "Корак {index}",
      "Узорак ревизије",
      "Нема узорка ревизије",
      "Учитавање података...",
      "Одустани од задатка",
      "Пошаљи завршен задатак",
      "Објави садржај"
    ],
    index: [
      "Тренутни статус",
      "Ваша тренутна оцена је <i style=\"color:#1989fa\">{currVip</i><br>можете преузети само тренутни <i style=\"color:#1989fa\">{currVip</i> ниво задатка<br>да ли желите да се придружите <i style=\"color:#dd6161\">{vip</i> нивоу",
      "Придружи се сада",
      "Молимо вас да изаберете категорију задатка",
      "Откажи",
      "Преостало",
      "Бесплатна достава",
      "Останите на вези"
    ],
    list: [
      "Листа задатака", "Потражња", "Преостало", "Захтев", "Пријем"
    ],
    show: [
      "Детаљи задатка", "Време куповине", "Статус испоруке", "Цена изнајмљивања", "Време испоруке", "Одбројавање до пријема", "Почетак сервирања", "Кодирање", "UNKONE"
    ]
  },
  postRecord: [
    "Управљање издањима", "Издање", "Укупно", "Завршено", "Рок", "Ревизија", "Одустајање", "Уредници"
  ],
  dayReport: [
    "Дневни извод", "Укупан приход", "Моја провизија", "Моје провизије", "Задаци које су завршили подређени", "Бенефиције задатака подређеног", "PCE", "Последњих 30 дана", "Количина", "Задатак", "Подређени", "Потрошња", "Датум"
  ],
  fundRecord: {
    default: [
     "Евиденција расхода",
      "Евиденција допуне",
      "Евиденција прихода",
      "Р",
      "И",
      "Е",
      "Евиденција повлачења",
    ],
    tabs: [
      "Приход", "Расход", "Допуна", "Повлачење"
    ],
    state: [
        'Све',
      'Допуна', //1 допуна
      'Повлачење', //2 повлачење
      'Објави задатак', //3 задатак
      'Платна пумпа', //4 пумпа
      'Повратак', //5 попуст
      'Мисија извршена', //6 провизија
      'Награде за активност', //7 регимент
      'Награде за препоруку', //8 распон
      'Надоградња', //9 куповина чланова
      'Откажи задатак', //10 опозови
      'Приход од инвестиција', //11 трансфер_ц
      'Пренос у инвестицију', //12 трансфер_р
      'Остали приходи', //13 Донирај
      'Донирај', //14
      'Црвена коверта', //15
      'Купи паметне роботе', //16
      'Срећно извлачење', //17
      'Повраћај новца за куповину ЛП картице', //18
    ]
  },
  promote: [
    "Твој најбољи пријатељ",
    "Позивам вас да се придружите {title}",
    "Референтни код",
    "Копирај код препоруке",
    "Копирајте линк позивнице",
    "Сачувајте QR код",
    "Промотивни подстицаји",
    "Сачувај постер успешно",//7
    "Чување постера није успело, покушајте још неколико пута или сачувајте снимак екрана.",
    "Молим вас, направите снимак екрана.",
    "Сачувај промотивни постер",
    "Сачувајте промотивни постер на телефону<br>Ако не успете, покушајте још неколико пута или сачувајте снимак екрана",
      "Тек када постанете званични запослени на нивоу ЛП-а, имате право да позовете пријатеље да се придруже!",
    "Позови",
    "<p>1. Бонус за препоруку: Регрутовањем нових чланова да се придруже SGM-у добићете бонус за препоруку.</p><p>2. Тимска провизија: Свакодневно можете добијати провизију од задатака подређених чланова.</p><p>3. Активности компаније: Компанија повремено покреће разне активности добротворне сврхе, укључујући извлачења среће, црвене коверте са новцем, физичке награде и друге активности и погодности.</p><p>4. Кумулативни бонус: Када кумулативни број позваних пријатеља достигне одређени број, можете добити одређену новчану награду на почетној страници платформе. Што се више акумулира, то је бонус већи.</p><p>5. Позиција у компанији: Када се ваш тим развије до одређеног обима, можете се придружити више позиција у компанији, као што су позиције млађег/средњег/вишег/менаџерског асистента, и можете добијати додатну плату сваког месеца. У SGM-у пружамо широк простор за развој свим запосленима. Сви имају једнаке могућности. Дозволите нам да заједно будемо сведоци успеха сваког члана!</p>",
    "Развој тима"
  ],
  teamReport: {
    default: [
      "Претрага", "Стање тима", "Погодности тима", "Допуна тима", "Повлачење тима", "Број првих наплата", "Број првих гурања", "Величина тима", "Нови тим", "PCE", "Ја", "Корисник", "Допуна", "Повлачења", "Повраћај", "Провизија", "Изаберите датум", "Нема података", "Износ повлачења", "Број повлачења", "Повраћај повлачења", "Број повлачења тима","Партнер тима", "Препоручени укупни приход", "Укупан приход од попуста за задатке", "Укупно повлачења тима нивоа 3", "Оцена", "Родитељ", "Позвани", "Листа чланова", "Укупан број чланова"
    ],
    tabs: [
      "Извештаји тима",
      "Мој тим"
    ],
    team: [
      "Ниво 1", "Ниво 2", "Ниво 3"
    ]
  },
  help: [
    "Помоћник",
  "Није доступно"
  ],
  message:[
      "Прикажи поруку",
      "Нема поруке"
  ],
  credit: [
    "Кредитни резултат",
      "Кредитна напомена",
      "Кредитни записи",
      "<p>Почетни кредитни резултат је 60 поена.</p><p>1: Ако је резултат мањи од 50 поена, број завршених дневних задатака биће преполовљен.</p><p>2: Ако је резултат мањи од 30 поена, дневни радни задаци не могу бити завршени.</p><p>3: Ако је резултат мањи од 10 поена, не можете се пријавити за подизање готовине.</p><p>Правила награђивања поенима: Надоградња нивоа рада додаће 5 поена, а позив подређенима да постану (формални запослени) додаће 1 поен.</p><p>Негативан став према послу, неблаговремено завршавање задатака и кршење прописа компаније утицаће на ваш лични кредитни резултат.</p>",
      "Мој кредит",
      "Тренутно нема кредитног записа"
  ],
  dialog: [
    "Савети", "Потврди", "Слање...", "Копирање је успешно", "Верзија iOS система је ниска и није подржана", "Регистрација...", "Учитавање података..."
  ],
  lineList: [
    "Избор линије",
      "Тренутна линија",
      "Линија"
  ],
  serviceCenter: [
    "Служба за кориснике",
      "Здраво, ексклузивна служба за кориснике",
      "Драго нам је да вам услужимо.",
      "Самопослуживање",
      "Онлајн служба за кориснике",
      "Служба за допуњавање рачуна",
      "Линејска служба за кориснике"
  ],
  direct:[
        'SGM',
        'Бонус за раст',
        "Опис активности",
          "<p>Након што директно позовете чланове да се придруже ЛП нивоу, можете добити новчане награде ако испуњавате услове!</p><p>На пример: ако кумулативно позовете 3 члана ЛП нивоа, можете директно добити награду. Након што је примите, наставите да остварујете друге циљеве и наставите да је примате.</p><p>Ексклузивна награда за раст SGM-а, сваку награду сваки запослени може добити само једном.</p>",
          "Број подређених",
          "Треба завршити",
          "Погодности позива",
          "Примање награда",
          "Примљено"
  ],
  activity:[
    'Добротворност', 'Детаљи', 'Донација', 'Стање на рачуну', 'Све', 'Плаћање', 'Молимо вас да унесете износ донације', 'Хвала вам на донацији'
  ],
  positions:{
    info:["Детаљи позиције", "Пријава за позицију", "Позиција", "Редовни запослени тима нивоа 3, ниво Г", "Однос чланова тима трећег нивоа", "Плата за овај месец", "Обрачун плате", "Завршено", "Треба да се заврши", "Примљено", "Време наплате плате"],
    job: ["Пошаљи на преглед", "У прегледу", "Прегледано", "Отпремите релевантна документа", "Коментари", "Кликните на слику да бисте изабрали и отпремили фотографију за личну карту.","Отпремите фотографију предње стране ваше личне карте на фотографији А.","Отпремите фотографију полеђине ваше личне карте на фотографији Б.","Отпремите фотографију себе како држите личну карту на фотографији Ц.","Фотографија А", "Фотографија Б", "Фотографија Ц","Молимо вас да изаберете позицију на коју желите да будете унапређени", "Позиција", "Основна плата", "Додатни бонус", "Обавештење за запослене", "Прочитао/ла сам и слажем се са садржајем《Смерница за пријаву за позицију》", "Пошаљи пријаву за позицију", "Молимо вас да изаберете позицију", "Молимо вас да изаберете фотографију А", "Молимо вас да изаберете фотографију Б", "Молимо вас да изаберете фотографију Ц"]
  },
}